module.exports = __webpack_public_path__ + "img/past_jackpot_bg.46288a38.png";